import EventEmitter from 'eventemitter3'

export const appLayoutEvents = new EventEmitter()
